export default {"src":"/_next/static/media/arrow-down.a4c3f0ff.svg","height":12,"width":12};